import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-lg w-full text-center">
        

        {/* Code */}
        <h1 className="text-6xl font-bold text-gray-800">404</h1>

        {/* Title */}
        <h2 className="mt-4 text-2xl font-semibold text-gray-700">
          Page Not Found
        </h2>

        {/* Subtitle */} 
        <p className="mt-2 text-gray-500">
          Sorry, the page you’re looking for doesn’t exist or was moved.
        </p>

        {/* Button */}
        <Link
          to="/"
          className="mt-6 inline-block px-6 py-3 text-lg font-medium text-white bg-blue-600 rounded-xl shadow-md hover:bg-blue-700 transition-all btn btn-primary m-5"
        >
          ⬅ Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
